export const truncateHtmlText = (htmlString: string, maxChars: number): string => {
  if (!htmlString) return '';
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  const wrapper = doc.body.firstChild as HTMLElement;
  let charCount = 0;

  const traverse = (node: Node): Node | null => {
    if (charCount >= maxChars) return null;

    if (node.nodeType === Node.TEXT_NODE) {
      const remaining = maxChars - charCount;
      const text = node.textContent?.slice(0, remaining) || '';
      charCount += text.length;
      return document.createTextNode(`${text}${charCount === maxChars ? '...' : ''}`);
    }

    if (node.nodeType === Node.ELEMENT_NODE) {
      const element = node as Element;
      const clone = element.cloneNode(false) as Element;
      for (const child of Array.from(element.childNodes)) {
        const result = traverse(child);
        if (result) clone.appendChild(result);
        if (charCount >= maxChars) break;
      }
      return clone;
    }

    return null;
  };

  const truncated = traverse(wrapper);
  const container = document.createElement('div');
  if (truncated) container.appendChild(truncated);
  return container.innerHTML;
};
